var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-action-dialog',{attrs:{"api-call":_vm.apiCall,"action":"Add BIN"},on:{"close":_vm.close}},[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_vm._v(" BIN: "),_c('v-text-field',{attrs:{"label":"BIN"},model:{value:(_vm.bin),callback:function ($$v) {_vm.bin=$$v},expression:"bin"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }